import {Options, Chart, AxisLabelsFormatterContextObject, PointLabelObject} from 'highcharts';
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class AccuracySpeed extends AbstractChart {
    protected allChartOptions(): Options {
        const axisLabels: Array<string> = $(this.target).data('axis-labels');
        const seriesData: Array<any> = $(this.target).data('series-data');
        const options: Options = {
            chart: {
                type: 'scatter',
                inverted: false,
                width: 600,
                height: 500,
                spacingTop: 5,
                marginTop: 30,
                spacingBottom: 30,
                marginRight: 60,
                marginLeft: 120,
                plotBorderWidth: 0,
                events: {
                    load: function (this: Chart): void {
                        // Add axis labels
                        this.renderer.label(
                            axisLabels[0], 305, -5
                        ).css({fontSize: '10pt'}).add();
                        this.renderer.label(
                            axisLabels[1], 550, 240
                        ).css({fontSize: '10pt'}).add();
                        this.renderer.label(
                            axisLabels[2], 290, 480
                        ).css({fontSize: '10pt'}).add();
                        this.renderer.label(
                            axisLabels[3], 57, 240
                        ).css({fontSize: '10pt'}).add();
                    }
                },
            },
            yAxis: {
                min: -4,
                max: 4,
                tickInterval: 1,
                lineWidth: 0,
                lineColor: 'black',
                gridLineColor: '#E6E6E6',
                offset: -208,
                title: {
                    text: null
                },
                labels: {
                    useHTML: true,
                    x: -5,
                    style: {
                        fontSize: '9pt',
                        color: 'black'
                    },
                    formatter: function (this: AxisLabelsFormatterContextObject) {
                        return this.value == 0 ? '' : this.value.toString();
                    },
                },
                plotLines: [
                    {
                        value: 0,
                        color: 'black',
                        width: 1,
                        zIndex: 4
                    }
                ]
            },
            xAxis: {
                gridLineWidth: 1,
                min: -4,
                max: 4,
                tickInterval: 1,
                lineWidth: 0,
                lineColor: 'black',
                offset: -221,
                opposite: true,
                labels: {
                    useHTML: true,
                    y: 30,
                    x: -8,
                    style: {
                        fontSize: '9pt',
                        color: 'black'
                    }
                },
                plotLines: [
                    {
                        value: 0,
                        color: 'black',
                        width: 1,
                        zIndex: 4
                    }
                ]
            },
            series: [
                {
                    // Upper half of the light grey square that marks the area of 2 and -2
                    type: 'area',
                    color: '#d2d3d5',
                    lineWidth: 0,
                    zIndex: 1,
                    marker: {
                        enabled: false
                    },
                    data: [[-2.01, 2], [2, 2]]
                },
                {
                    // Lower half of the light grey square that marks the area of 2 and -2
                    type: 'area',
                    color: '#d2d3d5',
                    lineWidth: 0,
                    zIndex: 1,
                    marker: {
                        enabled: false
                    },
                    data: [[-2.01, -2.01], [2, -2.01]]
                },
                {
                    // Upper half of the dark grey square that marks the area of 1 and -1
                    type: 'area',
                    color: '#a8a9ad',
                    lineWidth: 0,
                    zIndex: 1,
                    marker: {
                        enabled: false
                    },
                    data: [[-1, 0.98], [0.99, 0.98]]
                },
                {
                    // Lower half of the dark grey square that marks the area of 1 and -1
                    type: 'area',
                    color: '#a8a9ad',
                    lineWidth: 0,
                    zIndex: 1,
                    marker: {
                        enabled: false
                    },
                    data: [[-1, -0.99], [0.99, -0.99]]
                },
                {
                    type: 'scatter',
                    zIndex: 1000,
                    lineWidth: 0,
                    marker: {
                        symbol: 'circle',
                        fillColor: '#f9001d',
                        radius: 5,
                        lineWidth: 1,
                        lineColor: 'black'
                    },
                    dataLabels: {
                        enabled: true,
                        useHTML: true,
                        allowOverlap: true,
                        x: 11,
                        y: -3,
                        style: {
                            fontWeight: 'bold',
                            fontSize: '10pt',
                            color: 'black',
                            zIndex: 1000
                        },
                        formatter: function (this: PointLabelObject) {
                            return this.point.name;
                        }
                    },
                    data: seriesData,
                },
            ]
        };

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(AccuracySpeed)}